export default __webpack_public_path__ + "static/media/icon-error-red.bea157eb.svg";